export const languagesObject = {
  en: 'English',
  uk: 'Ukrainian',
  pl: 'Polish',
  ru: 'Russian',
  fr: 'French',
  pt: 'Portuguese',
  es: 'Spanish',
} as const;

export const agreementUrls: Partial<Record<keyof typeof languagesObject, string>> = {
  en: 'https://info.quick-appointment.com/agreement_en.html',
  uk: 'https://info.quick-appointment.com/agreement_uk.html',
  ru: 'https://info.quick-appointment.com/agreement_ru.html',
  es: 'https://info.quick-appointment.com/agreement_es.html',
};

export const calendarLocales = {
  English: 'en-US',
  Ukrainian: 'uk',
  Polish: 'pl',
  Russian: 'ru',
  French: 'fr',
  Portuguese: 'pt',
  Spanish: 'es',
} as const;
